<template>
  <div
    class="eu-display_flex eu-zindex_4 eu-position_relative eu-align-items_end"
  >
    <div
      class="emd-form-group eu-no-padding eu-mr_2 eu-basis_12 eu-shrink_1"
      data-children-count="1"
    >
      <label
        for="since"
        class="emd-text _type_label _color_primary _size_tiniest"
        >{{ $t('since') }}</label
      >
      <input-date
        aria-autocomplete="off"
        class="_size_small"
        :class="{ _state_error: startDate.hasError }"
        :locale="locale"
        :value="startDate.model"
        id="range-start"
        ref="range-start"
        name="start"
        @input="validateDate($event, 'startDate')"
      />
    </div>
    <div
      class="emd-form-group eu-no-padding eu-basis_12 eu-shrink_1"
      data-children-count="1"
    >
      <label
        for="until"
        class="emd-text _type_label _color_primary _size_tiniest"
        >{{ $t('until') }}</label
      >
      <input-date
        aria-autocomplete="off"
        class="_size_small"
        :class="{ _state_error: endDate.hasError }"
        :locale="locale"
        :value="endDate.model"
        id="range-end"
        ref="range-end"
        name="end"
        @input="validateDate($event, 'endDate')"
      />
    </div>
    <div class="eu-ml_2">
      <button
        type="submit"
        class="emd-btn _size_small _color_primary"
        @click="submit"
      >
        <i class="uil uil-search" />
      </button>
    </div>
  </div>
</template>

<script>
import InputDate from './InputDate'
import { formatDate } from '@/utils'

export default {
  name: 'RangeDatepickerFallback',
  components: {
    InputDate
  },
  props: {
    start: {
      type: [Object, String],
      required: false,
      default: ''
    },
    end: {
      type: [Object, String],
      required: false,
      default: ''
    },
    locale: {
      type: String,
      required: false,
      default: 'pt-BR'
    },
    limitDate: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      startDate: {
        hasError: false,
        name: 'sinceDate',
        model: this.start
      },
      endDate: {
        hasError: false,
        name: 'untilDate',
        model: this.end
      }
    }
  },
  methods: {
    submit () {
      this.$emit('onSubmit')
    },
    isDate (value) {
      return !(isNaN(value.getTime()) || value.getTime() < 0)
    },
    isEmpty (value) {
      return [undefined, null, ''].includes(value)
    },
    validatePeriod () {
      if (
        !this.isEmpty(this.startDate.model) &&
        !this.isEmpty(this.endDate.model)
      ) {
        const startDate = new Date(this.startDate.model)
        const endDate = new Date(this.endDate.model)
        if (
          this.isDate(startDate) &&
          this.isDate(endDate) &&
          startDate <= endDate
        ) {
          this.startDate.hasError = false
          this.endDate.hasError = false
        } else {
          this.startDate.hasError = true
          this.endDate.hasError = true
        }
      }
    },
    validateDate (event, date) {
      if (this[date].model !== event) {
        this[date].model = event
        const obj = {
          name: this[date].name,
          value: event,
          text: '',
          hasError: false
        }
        if ([null, undefined, ''].includes(event)) {
          this[date].hasError = false
        } else {
          if (event.length === 10) {
            const value = new Date(event)
            const limit = new Date(this.limitDate)
            if (
              this.isDate(value) &&
              this.limitDate &&
              value.toISOString() <= limit.toISOString()
            ) {
              this[date].hasError = false
              obj.value = event
              obj.text = formatDate(this.locale, event)
              this.validatePeriod()
            } else {
              this[date].hasError = true
            }
          } else {
            this[date].hasError = false
          }
        }
        obj.hasError = this[date].hasError
        this.$emit('changeDate', obj)
      }
    }
  }
}
</script>
